/**
 * ⏮ ◀ ▶ ⏭ — four equal 36 px buttons, no borders, `ink2` icons (R6.6).
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {SPACE} from '../../../theme/tokens';
import {useV2Theme} from '../../../theme/useV2Theme';
import NavButtonView from './NavButton.View';
import {MoveNavModel} from './model';

const ROW_HEIGHT = 44;

export default React.memo(function MoveNavView({
  current,
  total,
  atStart,
  atEnd,
  goTo,
  step,
}: MoveNavModel) {
  const tokens = useV2Theme(s => s.tokens);
  return (
    <View
      testID="v2-move-nav"
      style={[styles.nav, {boxShadow: `inset 0 1px 0 ${tokens.line}`} as any]}>
      <NavButtonView
        icon="first"
        disabled={current === 0}
        onPress={() => goTo(0)}
      />
      {/* review fix 2026-10-06: the branch's OWN cursor bounds, not `current`
          (pinned to its basePly) — see the model's own docblock */}
      <NavButtonView icon="prev" disabled={atStart} onPress={() => step(-1)} />
      <NavButtonView icon="next" disabled={atEnd} onPress={() => step(1)} />
      <NavButtonView
        icon="last"
        disabled={current >= total}
        onPress={() => goTo(total)}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  nav: {
    height: ROW_HEIGHT,
    flexGrow: 0,
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: SPACE.sm,
    gap: SPACE.xs,
  },
});
